import React, { useRef, useState } from "react";
import { ConnectBtn, DrawerDiv, InnerDrawer } from "./elements";
import { c98img, connectbtnimg, logo1 } from "assets";
import { Link } from "react-router-dom";
import { Modal, Tooltip } from "antd";
import MessageModal from "components/common/modal/messageModal";
import ConnectModal from "components/common/modal/connectModel/connectModal";
import { Image } from "react-bootstrap";
import { useWalletConnectClient } from "services/walletServices";
import { CommonUtility } from "utility/common";

function Drawer({ showConnectModal, setShowDrawer }) {
  const handleClick = () => {
    window.open("https://retrocraft.io/", "_blank");
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);
  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setDropdownVisible(false);
    }, 300);
  };

  const handleDropdownClick = () => {
    if (isDropdownVisible) {
      setDropdownVisible(false);
    } else {
      setDropdownVisible(true);
    }
  };
  const { account, clearLocalStorageAndResetStates } = useWalletConnectClient();
  return (
    <>
      <DrawerDiv
        onClick={() => setShowDrawer(false)}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        key={"drawer"}
        transition={{ delay: 0.1, duration: 0.2 }}
      >
        <InnerDrawer
          onClick={(e) => e.stopPropagation()}
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ delay: 0.1, duration: 0.2 }}
        >
          <svg
            className="close"
            onClick={() => setShowDrawer(false)}
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M2.0056 11.5249L0.922729 10.442L5.25423 6.11054L0.922729 1.77904L2.0056 0.696167L6.3371 5.02767L10.6686 0.696167L11.7515 1.77904L7.41998 6.11054L11.7515 10.442L10.6686 11.5249L6.3371 7.19342L2.0056 11.5249Z"
              fill="#E1C529"
            />
          </svg>

          <div className="top-logo-div">
            <Link to="/">
              <img className="" src={logo1} />
            </Link>
          </div>

          <div className="bottom-div">
            <Link
              to="/"
              onClick={() => {
                setShowDrawer(false);
                // handleClick();
              }}
            >
              <h1>Home</h1>
            </Link>

            <Link
              to="/"
              onClick={() => {
                setShowDrawer(false);
                scrollToSection("collection");
              }}
            >
              <h1>Collections</h1>
            </Link>
            <Link to="/mynft">
              <h1>My NFTs</h1>
            </Link>
            {/* <Tooltip
              title={
                <span>
                  Staking NFT will be available soon, please wait for the
                  announcement.
                </span>
              }
              color="#363636"
            > */}
            <Link to="/staking">
              <h1 className="staking-text">Staking</h1>
            </Link>
            {/* </Tooltip> */}

            {account ? (
              <div style={{ position: "relative" }}>
                <div
                  className="register-btn-div"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  ref={dropdownRef}
                >
                  <Image
                    src={connectbtnimg}
                    alt="button img"
                    className="btn-img"
                  />

                  <h1>
                    <Image src={c98img} />
                    &nbsp;&nbsp; {CommonUtility.addressConvertor(account)}
                  </h1>
                </div>

                {isDropdownVisible && (
                  <div
                    className="register-btn-div"
                    style={{ position: "absolute", top: "50px" }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={handleDropdownClick}
                  >
                    <Image
                      src={connectbtnimg}
                      alt="button img"
                      className="btn-img"
                    />

                    <h1 onClick={() => clearLocalStorageAndResetStates()}>
                      Disconnect
                    </h1>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div
                  className="register-btn-div"
                  onClick={() => {
                    setShowDrawer(false);
                    showConnectModal();
                  }}
                >
                  <Image
                    src={connectbtnimg}
                    alt="button img"
                    className="btn-img"
                  />

                  <h1>
                    <Image src={c98img} />
                    &nbsp;&nbsp; Connect Wallet
                  </h1>
                </div>
              </>
            )}
          </div>
        </InnerDrawer>
      </DrawerDiv>
    </>
  );
}

export default Drawer;
